<p-messages severity="warn" [closable]="true" *ngIf="isShows">
  <ng-template pTemplate>
    <div class="banner-template">
      <div class="close-banner-button" (click)="toggleBanner()">
        <i class="pi pi-times"></i>
      </div>
      <div class="banner-icon">
        <i class="pi pi-info-circle"></i>
      </div>
      <div class="vpn-banner-text">
        Если у вас включен VPN, то сайт может работать некорректно
      </div>
    </div>
  </ng-template>
</p-messages>
